import { Maybe } from 'types/graphqlTypes'
import { capitalize } from 'utils/capitalize'
import { DISPLAY } from 'constants/display'

export interface ILaneStop {
  city?: Maybe<string>
  stateCode?: Maybe<string>
}

/**
 * @example Output: "Fort Worth, TX -> Atlanta, GA"
 */
export const getLaneText = (
  firstPickup: Maybe<ILaneStop>,
  lastDelivery: Maybe<ILaneStop>,
  separator: string = '->'
): string => {
  const { city: pickupCity, stateCode: pickupState } = firstPickup ?? {}
  const { city: deliveryCity, stateCode: deliveryState } = lastDelivery ?? {}

  if (pickupCity && pickupState && deliveryCity && deliveryState) {
    const formattedPickupCity = capitalize(pickupCity)
    const formattedDeliveryCity = capitalize(deliveryCity)

    return `${formattedPickupCity}, ${pickupState} ${separator} ${formattedDeliveryCity}, ${deliveryState}`
  }

  return DISPLAY.empty
}
